import { Periode } from './periode.model';

export class Recette {
    public id: number;
    public nb_periode: number;
    public date_creation: Date;
    public date_modification: Date;
    public libelle_plante: string;
    public duree_germination: number;
    public nb_graines_germination: number;
    public temperature_germination: number;
    public id_fiche_culture: number;
    public periodes: Periode[];
    constructor(id,libelle_plante,nb_periode,date_creation,date_modification,duree_germination,nb_graines_germination,temperature_germination,id_fiche_culture) {
        this.id = id;
        this.libelle_plante = libelle_plante;
        this.nb_periode = nb_periode;
        this.date_creation = date_creation;
        this.date_modification = date_modification;
        this.duree_germination = duree_germination;
        this.nb_graines_germination = nb_graines_germination;
        this.temperature_germination = temperature_germination;
        this.id_fiche_culture = id_fiche_culture;
    }
}
